module.exports = __webpack_public_path__ + "static/img/mint_success.2ede04ab.svg";